<template>
  <div class="content-wrapper"  id='modalContent'>
    <ejs-diagram
      id='rackDiagram'
      ref='diagramObject'
      :width="width"
      :height="height"
      :nodes='nodes'
      :connectors='connectors'
      :constraints='constraints'
      :snapSettings='snapSettings'
      :pageSettings='pageSettings'
      :click='click'
      :selectionChange='selectionChange'
      :positionChange='positionChange'
    ></ejs-diagram>
  </div>
</template>
<script>
  // let nodesTest =  [
  //   {
  //     type: "BBU",
  //     desc: "BBU",
  //     offsetX: 0,
  //     offsetY: 0,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/bbu.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'BBU',
  //         style: { color: '#2B2B2B', fontSize: 16, bold: true, fontFamily: "sans-serif"},
  //         offset: {
  //           x: 0.5,
  //           y: 1
  //         },
  //         margin: {top: 30},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //   },
  //   {
  //     type: "FAU",
  //     desc: "FAU",
  //     command: "SHW",
  //     offsetX: 24,
  //     offsetY: 5,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/fau.png")
  //     },
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 75, top: 55},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'PRS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 75, top: 70},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     ports: [{
  //       id: 'port1',
  //       offset: {
  //         x: 0,
  //         y: 0
  //       },
  //       margin: {left: 51, top: 55},
  //       // margin: {left:20, bottom: 50},
  //       visibility: PortVisibility.Visible,
  //       style: {
  //         fill: '#FF0000',
  //         strokeWidth: 2,
  //         strokeColor: '#2B2B2B'
  //       },
  //       width: 16,
  //       height: 8,
  //       shape: 'Square'
  //     },
  //     {
  //       id: 'port2',
  //       offset: {
  //         x: 0,
  //         y: 0
  //       },
  //       margin: {left: 51, top: 70},
  //       visibility: PortVisibility.Visible,
  //       style: {
  //         fill: '#00FF00',
  //         strokeWidth: 2,
  //         strokeColor: '#2B2B2B'
  //       },
  //       width: 16,
  //       height: 8,
  //       shape: 'Square'
  //     }
  //   ]
  //   },
  //   {
  //     id: 'bpb1',
  //     type: "BPB",
  //     desc: "BPB",
  //     command: "SHW",
  //     offsetX: 129,
  //     offsetY: 5,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/bpb.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 9},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'RPS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 20},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'OPT',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 31},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'ETH',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 250, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'CPRI0',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 305, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'CPRI1',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 342, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'CPRI2',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 379, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 9},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 20},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port3',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       }
  //     ]
  //   },
  //   {
  //     id: 'bpb_port1',
  //     type: "BPB",
  //     desc: "BPB",
  //     command: "SHW",
  //     offsetX: 414,
  //     offsetY: 13,
  //     width: 36,
  //     height: 28,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "#2B2B2B",
  //       strokeWidth: 2
  //     },
  //     shape: 'Square',
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'bpb_port1_port1',
  //         offset: {
  //           x: 0.5,
  //           y: 0.5
  //         },
  //         visibility: PortVisibility.Hidden,
  //       }
  //     ]
  //   },
  //   {
  //     id: 'bpb_port2',
  //     type: "BPB",
  //     desc: "BPB",
  //     command: "SHW",
  //     offsetX: 451,
  //     offsetY: 13,
  //     width: 36,
  //     height: 28,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "#2B2B2B",
  //       strokeWidth: 2
  //     },
  //     shape: 'Square',
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs
  //   },
  //   {
  //     id: 'bpb_port3',
  //     type: "BPB",
  //     desc: "BPB",
  //     command: "SHW",
  //     offsetX: 488,
  //     offsetY: 13,
  //     width: 36,
  //     height: 28,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "#2B2B2B",
  //       strokeWidth: 2
  //     },
  //     shape: 'Square',
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs
  //   },
  //   {
  //     id: 'bpb2',
  //     type: "BPB",
  //     desc: "BPB",
  //     command: "SHW",
  //     offsetX: 129,
  //     offsetY: 59,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/bpb.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 9},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'RPS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 20},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'OPT',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 31},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'HAS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 42},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 9},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 20},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port3',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port4',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 42},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'mcb_port5',
  //         offset: {
  //           x: 1,
  //           y: 0
  //         },
  //         margin: {right: 22, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: 'none',
  //           strokeWidth: 0,
  //           // strokeColor: '#2B2B2B'
  //         },
  //         width: 27,
  //         height: 22,
  //         shape: 'Square'
  //       },
  //     ]
  //   },
  //   {
  //     id: 'bpb3',
  //     type: "BPB",
  //     desc: "BPB",
  //     command: "SHW",
  //     offsetX: 129,
  //     offsetY: 113,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/bpb.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 9},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'RPS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 20},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'OPT',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 31},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'HAS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 42},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 9},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 20},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port3',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port4',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 42},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'mcb_port5',
  //         offset: {
  //           x: 1,
  //           y: 0
  //         },
  //         margin: {right: 22, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: 'none',
  //           strokeWidth: 0,
  //           // strokeColor: '#2B2B2B'
  //         },
  //         width: 27,
  //         height: 22,
  //         shape: 'Square'
  //       },
  //     ]
  //   },
  //   {
  //     id: 'bpb4',
  //     type: "BPB",
  //     desc: "BPB",
  //     command: "SHW",
  //     offsetX: 129,
  //     offsetY: 167,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/bpb.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 9},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'RPS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 20},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'OPT',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 31},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'HAS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 42},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 9},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 20},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port3',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port4',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 42},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'mcb_port5',
  //         offset: {
  //           x: 1,
  //           y: 0
  //         },
  //         margin: {right: 22, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: 'none',
  //           strokeWidth: 0,
  //           // strokeColor: '#2B2B2B'
  //         },
  //         width: 27,
  //         height: 22,
  //         shape: 'Square'
  //       },
  //     ]
  //   },
  //   {
  //     id: 'svb5',
  //     type: "SVB",
  //     desc: "SVB",
  //     command: "SHW",
  //     offsetX: 550,
  //     offsetY: 5,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/svb.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 9},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'RPS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 20},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'OPT',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 31},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'USB',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 208, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'ETH',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 278, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'CONSOLE',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 330, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'DISPLAY',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 1,
  //           y: 1
  //         },
  //         margin: {right: 40, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 9},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 20},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port3',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       }
  //     ]
  //   },
  //   {
  //     id: 'bpb6',
  //     type: "BPB",
  //     desc: "BPB",
  //     command: "SHW",
  //     offsetX: 550,
  //     offsetY: 59,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/bpb.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 9},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'RPS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 20},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'OPT',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 31},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'HAS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 42},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 9},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 20},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port3',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port4',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 42},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'mcb_port5',
  //         offset: {
  //           x: 1,
  //           y: 0
  //         },
  //         margin: {right: 22, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: 'none',
  //           strokeWidth: 0,
  //           // strokeColor: '#2B2B2B'
  //         },
  //         width: 27,
  //         height: 22,
  //         shape: 'Square'
  //       },
  //     ]
  //   },
  //   {
  //     id: 'mcb7',
  //     type: "MCB",
  //     desc: "MCB",
  //     command: "SHW",
  //     offsetX: 550,
  //     offsetY: 113,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/mcb.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 9},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'RPS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 20},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'OPT',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 31},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'HAS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 42},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'GNSS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 148, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'EXT',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 196, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'ETH',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 245, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'CONSOLE',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 292, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'SFP0',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 342, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'SFP1',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 380, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 9},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 20},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port3',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port4',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 42},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'mcb_port5',
  //         offset: {
  //           x: 1,
  //           y: 0
  //         },
  //         margin: {right: 22, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: 'none',
  //           strokeWidth: 0,
  //           // strokeColor: '#2B2B2B'
  //         },
  //         width: 27,
  //         height: 22,
  //         shape: 'Square'
  //       },
  //     ]
  //   },
  //   {
  //     id: 'mcb_port1',
  //     type: "BPB",
  //     desc: "BPB",
  //     command: "SHW",
  //     offsetX: 872,
  //     offsetY: 121,
  //     width: 36,
  //     height: 28,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "#008000",
  //       strokeWidth: 2
  //     },
  //     shape: 'Square',
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs
  //   },
  //   {
  //     id: 'mcb_port2',
  //     type: "BPB",
  //     desc: "BPB",
  //     command: "SHW",
  //     offsetX: 909,
  //     offsetY: 121,
  //     width: 36,
  //     height: 28,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "#2B2B2B",
  //       strokeWidth: 2
  //     },
  //     shape: 'Square',
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs
  //   },
  //   {
  //     id: 'mcb8',
  //     type: "MCB",
  //     desc: "MCB",
  //     command: "SHW",
  //     offsetX: 550,
  //     offsetY: 167,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/mcb.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 9},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'RPS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 20},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'OPT',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 31},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'HAS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 42},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 9},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 20},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port3',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port4',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 42},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'mcb_port5',
  //         offset: {
  //           x: 1,
  //           y: 0
  //         },
  //         margin: {right: 22, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: 'none',
  //           strokeWidth: 0,
  //           // strokeColor: '#2B2B2B'
  //         },
  //         width: 27,
  //         height: 22,
  //         shape: 'Square'
  //       },
  //     ]
  //   },
  //   {
  //     type: "PSU",
  //     desc: "PSU",
  //     command: "SHW",
  //     offsetX: 971,
  //     offsetY: 5,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/psu.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 42, top: 40},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'PRS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 42, top: 55},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'POWER IN',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 136, top: 65},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 18, top: 40},
  //         // margin: {left:20, bottom: 50},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 18, top: 55},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       }
  //     ]
  //   },
  //   {
  //     type: "PSU",
  //     desc: "PSU",
  //     command: "SHW",
  //     offsetX: 971,
  //     offsetY: 86,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/psu.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 42, top: 40},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'PRS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 42, top: 55},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 18, top: 40},
  //         // margin: {left:20, bottom: 50},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 18, top: 55},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       }
  //     ]
  //   },
  //   {
  //     type: "EnvMB",
  //     desc: "EnvMB",
  //     command: "SHW",
  //     offsetX: 971,
  //     offsetY: 167,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/envmb.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 9},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'RPS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 20},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 9},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 20},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //     ]
  //   },
  //   {
  //     id: 'rru1',
  //     type: "rru",
  //     desc: "RRU",
  //     offsetX: 30,
  //     offsetY: 300,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/rru.png")
  //     },
  //     style: {
  //       fill: "none",
  //       strokeWidth: 0
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 27, top: 132},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'PRS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 50, top: 132},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'OPT',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 73, top: 132},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'HAS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 96, top: 132},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'SFP0',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 10, top: 7},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'ANT0',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 44, top: 7},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'ANT1',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 81, top: 7},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'SFP1',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 1,
  //           y: 1
  //         },
  //         margin: {right: 7, top: 7},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'rru1_port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 25, top: 120},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 1,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'rru1_port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 48, top: 120},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 1,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'rru1_port3',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 71, top: 120},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 1,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'rru1_port4',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 94, top: 120},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 1,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'rru1_port5',
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 9, bottom: 7},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: 'none',
  //           strokeWidth: 1,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 15,
  //         height: 12,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'rru1_port6',
  //         offset: {
  //           x: 1,
  //           y: 1
  //         },
  //         margin: {right: 9, bottom: 7},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: 'none',
  //           strokeWidth: 1,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 15,
  //         height: 12,
  //         shape: 'Square'
  //       },
  //     ]
  //   },
  //   {
  //     id: 'rru2',
  //     type: "rru",
  //     desc: "RRU",
  //     offsetX: 230,
  //     offsetY: 300,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/rru.png")
  //     },
  //     style: {
  //       fill: "none",
  //       strokeWidth: 0
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 27, top: 132},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'PRS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 50, top: 132},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'OPT',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 73, top: 132},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'HAS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 96, top: 132},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'SFP0',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 10, top: 7},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'ANT0',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 44, top: 7},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'ANT1',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 81, top: 7},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'SFP1',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 1,
  //           y: 1
  //         },
  //         margin: {right: 7, top: 7},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'rru2_port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 25, top: 120},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 1,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'rru2__port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 48, top: 120},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 1,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'rru2_port3',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 71, top: 120},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 1,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'rru2_port4',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 94, top: 120},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 1,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'rru2_port5',
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 9, bottom: 7},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: 'none',
  //           strokeWidth: 1,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 15,
  //         height: 12,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'rru2_port6',
  //         offset: {
  //           x: 1,
  //           y: 1
  //         },
  //         margin: {right: 9, bottom: 7},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: 'none',
  //           strokeWidth: 1,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 15,
  //         height: 12,
  //         shape: 'Square'
  //       },
  //     ]
  //   },
  // ];
  // let nodesTest2 =  [
  //   {
  //     type: "BBU",
  //     desc: "BBU",
  //     offsetX: 0,
  //     offsetY: 0,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/a-bg.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'BBU',
  //         style: { color: '#2B2B2B', fontSize: 16, bold: true, fontFamily: "sans-serif"},
  //         offset: {
  //           x: 0.5,
  //           y: 1
  //         },
  //         margin: {top: 30},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //   },
  //   {
  //     type: "FAU",
  //     desc: "FAU",
  //     command: "SHW",
  //     offsetX: 24,
  //     offsetY: 5,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/fau.png")
  //     },
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 75, top: 55},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'PRS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 75, top: 70},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     ports: [{
  //       id: 'port1',
  //       offset: {
  //         x: 0,
  //         y: 0
  //       },
  //       margin: {left: 51, top: 55},
  //       // margin: {left:20, bottom: 50},
  //       visibility: PortVisibility.Visible,
  //       style: {
  //         fill: '#FF0000',
  //         strokeWidth: 2,
  //         strokeColor: '#2B2B2B'
  //       },
  //       width: 16,
  //       height: 8,
  //       shape: 'Square'
  //     },
  //       {
  //         id: 'port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 51, top: 70},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       }
  //     ]
  //   },
  //   {
  //     id: 'emb1',
  //     type: "EMB",
  //     desc: "EMB",
  //     command: "SHW",
  //     offsetX: 129,
  //     offsetY: 5,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/emb.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 9},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'RPS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 20},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'OPT',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 31},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'IRGI',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 115, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'CLK',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 140, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'GNSS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 169, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'DEBUG',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 204, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'MGMT',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 242, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'SFP0',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 283, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'SFP1',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 321, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'SFP2',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 358, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'SFP3',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 1,
  //           y: 1
  //         },
  //         margin: {right: 25, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 9},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 20},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port3',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       }
  //     ]
  //   },
  //   {
  //     id: 'mpb2',
  //     type: "MPB",
  //     desc: "MPB",
  //     command: "SHW",
  //     offsetX: 129,
  //     offsetY: 59,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/mpb.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 9},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'RPS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 20},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'OPT',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 31},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'HAS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 42},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'USB0',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 164, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'USB1',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 207, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'DEBUG',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 253, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 9},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 20},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port3',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port4',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 42},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'mcb_port5',
  //         offset: {
  //           x: 1,
  //           y: 0
  //         },
  //         margin: {right: 22, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: 'none',
  //           strokeWidth: 0,
  //           // strokeColor: '#2B2B2B'
  //         },
  //         width: 27,
  //         height: 22,
  //         shape: 'Square'
  //       },
  //     ]
  //   },
  //   {
  //     id: 'nrb3',
  //     type: "NRB",
  //     desc: "NRB",
  //     command: "SHW",
  //     offsetX: 129,
  //     offsetY: 113,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/nrb.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 9},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'RPS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 20},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'OPT',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 31},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'HAS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 42},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'DEBUG0',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 180, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'DEBUG1',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 226, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'CPRI0',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 273, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'CPRI1',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 311, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'CPRI2',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 348, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'CPRI3',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 1,
  //           y: 1
  //         },
  //         margin: {right: 35, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 9},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 20},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port3',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port4',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 42},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'mcb_port5',
  //         offset: {
  //           x: 1,
  //           y: 0
  //         },
  //         margin: {right: 22, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: 'none',
  //           strokeWidth: 0,
  //           // strokeColor: '#2B2B2B'
  //         },
  //         width: 27,
  //         height: 22,
  //         shape: 'Square'
  //       },
  //     ]
  //   },
  //   {
  //     id: 'bpb4',
  //     type: "BPB",
  //     desc: "BPB",
  //     command: "SHW",
  //     offsetX: 129,
  //     offsetY: 167,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/bpb.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 9},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'RPS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 20},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'OPT',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 31},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'HAS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 42},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 9},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 20},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port3',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port4',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 42},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'mcb_port5',
  //         offset: {
  //           x: 1,
  //           y: 0
  //         },
  //         margin: {right: 22, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: 'none',
  //           strokeWidth: 0,
  //           // strokeColor: '#2B2B2B'
  //         },
  //         width: 27,
  //         height: 22,
  //         shape: 'Square'
  //       },
  //     ]
  //   },
  //   {
  //     id: 'svb5',
  //     type: "SVB",
  //     desc: "SVB",
  //     command: "SHW",
  //     offsetX: 550,
  //     offsetY: 5,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/svb.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 9},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'RPS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 20},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'OPT',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 31},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'USB',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 208, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'ETH',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 278, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'CONSOLE',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 330, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'DISPLAY',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 1,
  //           y: 1
  //         },
  //         margin: {right: 40, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 9},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 20},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port3',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       }
  //     ]
  //   },
  //   {
  //     id: 'bpb6',
  //     type: "BPB",
  //     desc: "BPB",
  //     command: "SHW",
  //     offsetX: 550,
  //     offsetY: 59,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/bpb.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 9},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'RPS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 20},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'OPT',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 31},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'HAS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 42},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 9},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 20},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port3',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port4',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 42},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'mcb_port5',
  //         offset: {
  //           x: 1,
  //           y: 0
  //         },
  //         margin: {right: 22, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: 'none',
  //           strokeWidth: 0,
  //           // strokeColor: '#2B2B2B'
  //         },
  //         width: 27,
  //         height: 22,
  //         shape: 'Square'
  //       },
  //     ]
  //   },
  //   {
  //     id: 'mcb7',
  //     type: "MCB",
  //     desc: "MCB",
  //     command: "SHW",
  //     offsetX: 550,
  //     offsetY: 113,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/mcb.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 9},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'RPS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 20},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'OPT',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 31},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'HAS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 42},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'GNSS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 148, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'EXT',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 196, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'ETH',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 245, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'CONSOLE',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 292, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'SFP0',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 342, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'SFP1',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 380, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 9},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 20},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port3',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port4',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 42},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'mcb_port5',
  //         offset: {
  //           x: 1,
  //           y: 0
  //         },
  //         margin: {right: 22, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: 'none',
  //           strokeWidth: 0,
  //           // strokeColor: '#2B2B2B'
  //         },
  //         width: 27,
  //         height: 22,
  //         shape: 'Square'
  //       },
  //     ]
  //   },
  //   {
  //     id: 'mcb8',
  //     type: "MCB",
  //     desc: "MCB",
  //     command: "SHW",
  //     offsetX: 550,
  //     offsetY: 167,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/mcb.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 9},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'RPS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 20},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'OPT',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 31},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'HAS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 42},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 9},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 20},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port3',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port4',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 42},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'mcb_port5',
  //         offset: {
  //           x: 1,
  //           y: 0
  //         },
  //         margin: {right: 22, top: 31},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: 'none',
  //           strokeWidth: 0,
  //           // strokeColor: '#2B2B2B'
  //         },
  //         width: 27,
  //         height: 22,
  //         shape: 'Square'
  //       },
  //     ]
  //   },
  //   {
  //     type: "EnvMB",
  //     desc: "EnvMB",
  //     command: "SHW",
  //     offsetX: 971,
  //     offsetY: 167,
  //     pivot: {
  //       x: 0,
  //       y: 0
  //     },
  //     style: {
  //       fill: "none",
  //       strokeColor: "",
  //       strokeWidth: 0
  //     },
  //     shape: {
  //       type: 'Image',
  //       source: require("./img/eib.png")
  //     },
  //     annotations: [
  //       {
  //         content: 'ALM',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 9},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'RPS',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 88, top: 20},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'EXT0',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 131, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'EXT1',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 0,
  //           y: 1
  //         },
  //         margin: {left: 169, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       },
  //       {
  //         content: 'EXT2',
  //         style: { color: '#2B2B2B', bold: true, fontSize: 10, fontFamily: "Arial"},
  //         offset: {
  //           x: 1,
  //           y: 1
  //         },
  //         margin: {right: 29, bottom: 11},
  //         constraints: ~AnnotationConstraints.InheritReadOnly
  //       }
  //     ],
  //     constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs,
  //     ports: [
  //       {
  //         id: 'port1',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 9},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#FF0000',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //       {
  //         id: 'port2',
  //         offset: {
  //           x: 0,
  //           y: 0
  //         },
  //         margin: {left: 65, top: 20},
  //         visibility: PortVisibility.Visible,
  //         style: {
  //           fill: '#00FF00',
  //           strokeWidth: 2,
  //           strokeColor: '#2B2B2B'
  //         },
  //         width: 16,
  //         height: 8,
  //         shape: 'Square'
  //       },
  //     ]
  //   }
  // ];
  // let connectionsTest = [
  //   {
  //     id: 'connector1',
  //     sourceID: 'bpb_port1',
  //     sourcePortID: 'bpb_port1_port1',
  //     targetID: 'rru1',
  //     targetPortID: 'rru1_port5',
  //     style: { strokeColor: "#5D6D7E", strokeWidth: 2 },
  //     sourceDecorator: { shape: 'None'},
  //     targetDecorator: { shape: 'None'},
  //     type: 'Orthogonal'//Orthogonal
  //   },
  //   {
  //     id: 'connector2',
  //     sourceID: 'bpb_port1',
  //     targetID: 'rru1',
  //     targetPortID: 'rru1_port6',
  //     style: { strokeColor: "#5D6D7E", strokeWidth: 2 },
  //     sourceDecorator: { shape: 'None'},
  //     targetDecorator: { shape: 'None'},
  //     type: 'Orthogonal'//Orthogonal
  //   },
  //   {
  //     id: 'connector3',
  //     sourceID: 'rru1',
  //     sourcePortID: 'rru1_port6',
  //     targetID: 'rru2',
  //     targetPortID: 'rru2_port5',
  //     style: { strokeColor: "#5D6D7E", strokeWidth: 2 },
  //     sourceDecorator: { shape: 'None'},
  //     targetDecorator: { shape: 'None'},
  //     type: 'Orthogonal'//Orthogonal,Straight
  //   }
  // ];
  import Vue from "vue";
  import socketInstance from '../../../plugins/stompSock';
  import bus from './bus.js';
  import { EventBus } from '../../../plugins/eventBus';
  import {
    Diagram,
    PageSettingsModel,
    ScrollSettingsModel,
    DiagramPlugin,
    DiagramConstraints,
    ConnectorBridging,
    ConnectorConstraints,
    NodeConstraints,
    SnapConstraints,
    AnnotationConstraints,
    PortVisibility
  } from "@syncfusion/ej2-vue-diagrams";
  import {
    createSpinner,
    showSpinner,
    hideSpinner
  } from '@syncfusion/ej2-vue-popups';
  Diagram.Inject(ConnectorBridging);
  Vue.use(DiagramPlugin);
  export default {
    name: 'RackRightPanel',
    data() {
      return {
        tab: {
          headerText: { text: '机架图' }
        },
        // width: '100%',
        width: document.body.clientWidth - 282,
        // height: "300px",
        height: "calc(100vh - 100px)",
        diagramInstance: null,
        pageSettings: {
          margin: {top: 10, left: 0, rigth: 0, bottom: 0},
          width: document.body.clientWidth - 300,
          height:1500,
          showPageBreaks: false,
          boundaryConstraints: 'Page  ',//Diagram
          // background: {
          //     color: 'grey'
          // },
          // orientation: 'Portrait ',
          // multiplePage: true,
          // showPageBreaks: true,
        },
        scrollSettings: { canAutoScroll: false},
        selectNodes: [],
        almPortNodes: [],
        constraints: DiagramConstraints.Default | DiagramConstraints.Bridging,
        nodes: [],
        connectors: [],
        treeId: null,
        alarmInterval: null,
        boardAlarmInterval: null,
        portFill: "#828282",
        almLevel: ["#FF0000","#FF8000","#FFFF80","#C0FFFF"],
        snapSettings: { constraints: SnapConstraints.None },
        websocketSetting: [
          { topic: '/user/#/RackBoardStatusServer', clientId: 'rack', callback: this.boardWebSocketCallback }
        ],
      };
    },
    created() {
      this.treeId = localStorage.getItem('rackNowTab');
      this.webSocketInit();
    },
    mounted() {
      const $this = this;
      $this.diagramInstance = $this.$refs.diagramObject.ej2Instances;
      // createSpinner({target: document.getElementById('modalContent'), label: $this.$t('Topo.topoLoad')});
      bus.$on('loadRackDiagrams', (treeNode) => {
        $this.nodes = [];
        $this.connectors = [];
        $this.diagramInstance.clear();
        document.getElementById("rackDiagramcontent").scrollTop = 0;
        clearInterval($this.alarmInterval);
        clearInterval($this.boardAlarmInterval);
        if (treeNode != null) {
          $this.treeId = treeNode.id;
          $this.loadData();
        }
        // const div = document.getElementById("rackDiagramcontent");
        // const height = document.body.clientHeight - 105;
        // div.style.height=height + 'px';
        // div.style.overflow='scroll';
      });
    },
    methods: {
      click(args) {
        const $this = this;
        console.log("click", args);
        const clickNode = args.element;
        // clickNode.zIndex = 111;
        const flag = clickNode !== null && clickNode.id !== undefined;
        $this.selectNodes.forEach(node => {
          if (flag && node.id === clickNode.id) {
            return true;
          } else if (node.propName === "connectors") {
            node.style.strokeColor = "#5D6D7E";
            node.style.strokeWidth = 2;
          } else {
            node.style.strokeWidth = 0;
          }
        });
        $this.selectNodes = [];
        if (flag && (clickNode.id.indexOf("cpri") > -1 || clickNode.id.indexOf("sfp") > -1)) {
          const startToEnd = [];
          $this.diagramInstance.nodes.forEach(node => {
            if (node.parentPortId !== undefined && node.parentPortId.indexOf(clickNode.id) > -1) {//获取rru
              $this.selectNodes.push(node);
            } else if (node.parentPortId === undefined && (node.id.indexOf("cpri") > -1 || node.id.indexOf("sfp") > -1)) {
              startToEnd.push(node);
            }
          });
          if ($this.selectNodes.length > 0) {
            let parentPortId = $this.selectNodes[0].parentPortId;
            startToEnd.forEach(node => {
              if (parentPortId.indexOf(node.id) > -1) {//获取链路的起始跟终止节点
                $this.selectNodes.push(node);
              }
            });
          }
          $this.diagramInstance.connectors.forEach(connector => {
            if (connector.parentPortId !== undefined && connector.parentPortId.indexOf(clickNode.id) > -1) {//获取rru
              $this.selectNodes.push(connector);
            }
          });
          $this.diagramInstance.select($this.selectNodes);
        }
      },
      selectionChange(args) {
        args.oldValue.forEach(node => {
          if (node.propName === "connectors") {
            node.style.strokeColor = "#5D6D7E";
            node.style.strokeWidth = 2;
          } else {
            node.style.strokeWidth = 0;
          }
        });
        if (args.newValue instanceof Array && args.newValue.length > 0) {
          args.newValue.forEach(node => {
            if (node.propName === "connectors") {
              node.style.strokeColor = "#008000";
              node.style.strokeWidth = 2;
            } else if (node.id.indexOf("cpri") > -1 || node.id.indexOf("sfp") > -1) {
              node.style.strokeColor = "#008000";
              node.style.strokeWidth = 2;
            } else {
              node.style.strokeColor = "#008000";
              node.style.strokeWidth = 5;
            }

          });
        }
      },
      positionChange(args) {
        if (args.source.nodes !== undefined) {//多选
          let offset = null;
          if (args.newValue.offsetX < 10) {
            offset= 10 - args.newValue.offsetX;
            args.source.nodes.forEach(node => {
              if (node.id.indexOf("cpri") == -1 && node.id.indexOf("sfp") == -1) {
                node.offsetX += offset;
              }
            })
          }
          if (args.newValue.offsetY < 10) {
            offset= 10 - args.newValue.offsetY;
            this.diagramInstance.selectedItems.nodes.forEach(node => {
              if (node.id.indexOf("cpri") == -1 && node.id.indexOf("sfp") == -1) {
                node.offsetY += offset;
              }
            })
          }
          offset = this.width - args.source.width - 14;
          if (args.newValue.offsetX > offset) {
            offset= args.newValue.offsetX - offset ;
            args.source.nodes.forEach(node => {
              if (node.id.indexOf("cpri") == -1 && node.id.indexOf("sfp") == -1) {
                node.offsetX -= offset;
              }
            })
          }
          offset = 1500 - args.source.height - 15;
          if (args.newValue.offsetY > offset) {
            offset= args.newValue.offsetY - offset;
            this.diagramInstance.selectedItems.nodes.forEach(node => {
              if (node.id.indexOf("cpri") == -1 && node.id.indexOf("sfp") == -1) {
                node.offsetY -= offset;
              }
            })
          }
        } else if (args.source.type === 'rru') {//切换元素未选中状态
          const  node = this.diagramInstance.selectedItems.nodes[0];
          let offset = null;
          if (args.newValue.offsetX < 10) {
            offset= 10 - args.newValue.offsetX;
            node.offsetX += offset;
          }
          if (args.newValue.offsetY < 10) {
            offset= 10 - args.newValue.offsetY;
            node.offsetY += offset;
          }
          offset = this.width - 120 - 14;
          if (args.newValue.offsetX > offset) {
            offset= args.newValue.offsetX - offset ;
            node.offsetX -= offset;
          }
          offset = 1500 - 166 - 15;
          if (args.newValue.offsetY > offset) {
            offset= args.newValue.offsetY - offset;
            node.offsetY -= offset;
          }
        }
        // if (args.newValue.offsetY >= document.body.clientHeight - 208) {
        //   currentNode.offsetY = document.body.clientHeight - 208;
        // }
      },
      loadData() {
        const $this = this;
        // showSpinner(document.getElementById('modalContent'));
        this.$loading.showLoadding($this.$t('Topo.topoLoad'));
        $this.$axios.get(`/lte/ems/rack/queryRackData/${$this.treeId}`).then((response) => {
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            const result = response.data.resultVal;
            const screenWidth = document.body.clientWidth - 280 ;
            const marginLeft = 50;
            const marginTop = 50;
            const offsetWidth = (screenWidth - result.nodes[0].width) / 2;//后续如果涉及到不同形状的机框，需要遍历取最大width
            const offsetHeight = result.nodes[0].height + marginLeft;//后续如果涉及到不同形状的机框，需要遍历取最大height
            result.nodes.forEach(data => {
              const node = {
                id: data.id,
                pivot: {
                  x: 0,
                  y: 0
                },
                offsetX: data.offsetX + offsetWidth,
                offsetY: data.offsetY + marginTop,
                style: {
                  fill: "none",
                  strokeColor: "",
                  strokeWidth: 0
                },
                shape: {
                  type: data.shape.type,
                  source: require('./img/' + data.shape.source)
                },
                annotations: data.annotations,
                ports: data.ports,
                constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize & ~NodeConstraints.Tooltip & ~NodeConstraints.InheritTooltip & ~NodeConstraints.Drag) | NodeConstraints.HideThumbs,
              };
              $this.nodes.push(node);
              if (data.subObject !== undefined && data.subObject !== null) {
                data.subObject.forEach(subData => {
                  const subNode = {
                    id: subData.id,
                    pivot: {
                      x: 0,
                      y: 0
                    },
                    offsetX: subData.offsetX + offsetWidth,
                    offsetY: subData.offsetY + 50,
                    width: subData.width,
                    height: subData.height,
                    style: subData.style,
                    shape: subData.shape,
                    ports: subData.ports,
                    constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize & ~NodeConstraints.Tooltip & ~NodeConstraints.InheritTooltip & ~NodeConstraints.Drag) | NodeConstraints.HideThumbs,
                  };
                  $this.nodes.push(subNode);
                })
              }
            });
            //------------------计算RRU位置--------------------------
            let rrulineNum = 1;
            let rruOffsetWidth = marginLeft;
            let rruOffsetHeight = offsetHeight;
            // let flag = false;
            result.rrus.forEach((rruData, index) => {
              if (index == 0) {
                rrulineNum =  Math.round((screenWidth - marginLeft) / (rruData.width + marginLeft));
                rruOffsetHeight += marginTop;
                // } else if (index % rrulineNum == 0 && index % 2 == 0) {
                //   rruOffsetHeight += rruData.height + marginTop;
                //   flag = true;
              } else if (index % rrulineNum == 0) {
                rruOffsetHeight += rruData.height + marginTop;
                rruOffsetWidth = marginLeft;
                //   flag = false;
                // } else if (flag) {
                //   rruOffsetWidth = rruOffsetWidth - marginLeft - rruData.width;
              } else {
                rruOffsetWidth += rruData.width + marginLeft;
              }
              const rruNode = {
                type: 'rru',
                id: rruData.id,
                parentPortId: rruData.parentPortId,
                pivot: {
                  x: 0,
                  y: 0
                },
                offsetX: rruData.offsetX + rruOffsetWidth,
                offsetY: rruData.offsetY + rruOffsetHeight,
                style: {
                  fill: "none",
                  strokeColor: "",
                  strokeWidth: 0
                },
                shape: {
                  type: rruData.shape.type,
                  source: require('./img/' + rruData.shape.source)
                },
                annotations: rruData.annotations,
                ports: rruData.ports,
                constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize & ~NodeConstraints.Tooltip & ~NodeConstraints.InheritTooltip) | NodeConstraints.HideThumbs,
              };
              $this.nodes.push(rruNode);
            });
            result.connections.forEach((data) => {
              const connection = {
                // id: data.id,
                parentPortId: data.parentPortId,
                sourceID: data.sourceID != undefined ? data.sourceID : null,
                sourcePortID: data.sourcePortID,
                targetID: data.targetID,
                targetPortID: data.targetPortID,
                style: {strokeColor: "#5D6D7E", strokeWidth: 2},
                sourceDecorator: {shape: 'None'},
                targetDecorator: {shape: 'None'},
                constraints: ~ConnectorConstraints.Drag & ~ConnectorConstraints.DragSourceEnd & ~ConnectorConstraints.DragTargetEnd,
                type: "Straight"//OrthogonalStraight
              };
              $this.connectors.push(connection);
            });
            // hideSpinner(document.getElementById('modalContent'));
            this.$loading.hideLoadding();
            $this.refreshLoadAlarm();
            $this.refreshBoardAlarm();
          } else {
            // hideSpinner(document.getElementById('modalContent'));
            this.$loading.hideLoadding();
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        });

      },
      loadAlarm() {
        const $this = this;
        $this.almPortNodes = [];
        $this.$axios.get(`/lte/ems/rack/queryRackAlarm/${$this.treeId}`).then((response) => {
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            const result = response.data.resultVal;
            let id = "";
            const map = new Map();
            if (result != null) {
              result.forEach(data => {
                id = "#" + data.cabinet + "#" + data.frame + "#" + data.slot + "#";
                map.set(id, data.level);
              });
            }
            $this.diagramInstance.nodes.forEach(node => {
              if (map.has(node.id)) {
                const portNode = node.ports[0];
                const alarmLevel = map.get(node.id);
                portNode.style.fill = portNode.fillRange[alarmLevel];
                portNode.level = alarmLevel;
                $this.almPortNodes.push(portNode);
              } else if (node.ports != null && node.ports.length > 0 && node.id.indexOf("cpri") == -1 && node.id.indexOf("sfp") == -1) {
                const portNode = node.ports[0];
                // console.log("portNode", portNode)
                portNode.style.fill = portNode.fillRange['none'];
              }
            });
            // const node = $this.diagramInstance.getNodeObject(id);

          } else {
            // $this.$layer.alert({ msg: $this.$t('Track.error') });
            console.log('queryRackAlarm',response.data.errorString);
          }
        });
      },
      refreshLoadAlarm() {
        this.loadAlarm();
        if (this.alarmInterval != null) {
          clearInterval(this.alarmInterval);
        }
        this.alarmInterval = setInterval(this.loadAlarm, 10000);
      },
      refreshBoardAlarm() {
        const $this = this;
        var showFlag = true;
        if (this.boardAlarmInterval != null) {
          clearInterval(this.boardAlarmInterval);
        }
        this.boardAlarmInterval = setInterval(function () {
          showFlag = !showFlag;
          $this.almPortNodes.forEach(function (node) {
            if (showFlag) {
              node.style.fill = $this.almLevel[node.level];
            } else {
              node.style.fill = $this.portFill;
            }
          })
        }, 1000);
      },
      webSocketInit() {
        this.websocketSetting[0].clientId = `rack_${this.treeId}`;
        if (socketInstance.stompClient == null) {
          socketInstance.init(this.websocketSetting);
        } else {
          socketInstance.dynamicSubscribe(this.websocketSetting[0].topic, this.websocketSetting[0].clientId, this.boardWebSocketCallback);
        }
        // socketInstance.init(this.websocketSetting);
      },
      boardWebSocketCallback(msg) {
        if (msg) {
          const $this = this;
          const boardStatusData = JSON.parse(msg.body);
          const nodeId = "#" + boardStatusData.shNum + "#" + boardStatusData.chNum + "#" + boardStatusData.slNum + "#";
          this.diagramInstance.nodes.forEach(node => {
            if (node.id === nodeId) {
              node.ports.forEach(portNode => {
                for (const propertyName in boardStatusData) {
                  if (portNode.id === (nodeId + propertyName + "#")) {
                    portNode.style.fill = portNode.fillRange[boardStatusData[propertyName]];
                  }
                }
              })
            }
          });
        }
      },
    },
    beforeDestroy() {
      bus.$off('loadRackDiagrams');
      socketInstance.stopReceiveTopicMsg(this.websocketSetting[0].clientId, this.websocketSetting[0].topic);
      clearInterval(this.alarmInterval);
      clearInterval(this.boardAlarmInterval);
    }
  };
</script>

<style scoped>
  /*/deep/ ::-webkit-scrollbar {!*滚动条整体样式*!*/
  /*width: 8px !important;     !*高宽分别对应横竖滚动条的尺寸*!*/
  /*height: 8px !important;*/
  /*}*/
  .content-wrapper {
    background-color: white;
    background-size: contain;
    /*background-repeat: no-repeat;*/
    /*height: 75px;*/
    /*width: calc((100% - 12px) / 3);*/
    /*cursor: pointer;*/
    /*border: 1px solid #d5d5d5;*/
    /*background-position: center;*/
    /*float: left;*/
  }
</style>
